if (!customElements.get("set-recently-viewed") && !customElements.get("recently-viewed")) {
  class SetRecentlyViewed extends HTMLElement {
    constructor() {
      super();

      this.productHandle = this.dataset.productHandle;
    }

    connectedCallback() {
      setTimeout(() => {
        this.setRecentlyViewedProducts();
      }, 0);
    }

    setRecentlyViewedProducts() {
      const productHandles = this.getProductHandles(this.productHandle);
      let productHandlesArray = [];
      if (productHandles) {
        productHandlesArray = decodeURI(productHandles).split(",");
      }

      let productsToRender = productHandlesArray;

      if (this.productHandle) {
        if (productHandlesArray.includes(this.productHandle)) {
          productsToRender = productHandlesArray.filter((handle) => {
            return handle !== this.productHandle;
          });
        } else {
          let newHandles = [this.productHandle].concat(productHandlesArray);
          this.setCookieProducts(newHandles);
        }
      }
    }

    getProductHandles(productHandle) {
      let productHandles = Cookies.get("recentlyViewed");
      if (!productHandles) {
        Cookies.set("recentlyViewed", productHandle, {
          expires: 30,
          path: "/",
        });
        productHandles = Cookies.get("recentlyViewed");
      }
      return productHandles;
    }

    setCookieProducts(productHandlesArray) {
      Cookies.set("recentlyViewed", decodeURI(productHandlesArray.join(",")), {
        expires: 30,
        path: "/",
      });
    }
  }
  customElements.define("set-recently-viewed", SetRecentlyViewed);
}